import paths from "@ingka/icons-shared/paths/notice-red-small";
import { renderPaths } from "../renderPaths.mjs";
var notice_red_small_default = () => renderPaths(paths);
export {
  notice_red_small_default as default
};
